import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../../utility/Utility";
import CustomLoader from "../../../Components/CustomLoader/CustomLoader";

export default function AddVehicleManufacturersCompanys() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    companyName: "",
    description: "",
    isActive: true,
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        companyName: formData.companyName,
        description: formData.description,
        isActive: formData.isActive,
      };

      const response = await postData("/api/company/create", payload);
      if (response?.success) {
        toast.success(response.message || "Company created successfully!");
        navigate(-1);
      } else {
        throw new Error(response?.error || "Failed to create company");
      }
    } catch (error) {
      toast.error(error.message || "Error creating company");
      console.error("Create company error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={5000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 px-2 d-flex align-items-center justify-content-between">
            <div>
              <h4 className="mb-1">Insurance Company Management</h4>
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">Companies</li>
                <li className="breadcrumb-item active">
                  Add Insurance Company
                </li>
              </ol>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <i className="fas fa-arrow-left me-1"></i> Back
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <h5 className="mb-4">Add New Insurance Company</h5>

              <form onSubmit={handleSubmit}>
                <div className="mb-3 row">
                  <label
                    htmlFor="companyName"
                    className="col-sm-3 col-form-label"
                  >
                    Company Name <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      className="form-control"
                      placeholder="Enter official name of the insurance company"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3 row">
                  <label
                    htmlFor="description"
                    className="col-sm-3 col-form-label"
                  >
                    Description/About <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">
                    <textarea
                      id="description"
                      name="description"
                      className="form-control"
                      placeholder="Enter short company profile or description"
                      value={formData.description}
                      onChange={handleInputChange}
                      rows="4"
                      required
                    ></textarea>
                  </div>
                </div>

                <div className="text-end mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => navigate("/companies-list")}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Company"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
